import Link from 'next/link'
import {
  Input,
  Button,
  Error,
  FormControlWrapper
} from '../uiLib'
import { defaultValidators } from '../../lib/validation'

export const AlreadyAuthorized = ({ user }) => (
  <div>
    <h1>Login</h1>
    <p>You are already logged in as {user.username}</p>
  </div>
)

export const Login = props => {
  const usernameText = props.t('common:username')
  const passwordText = props.t('common:password')
  const usernameTipText = props.t('common:username-tip')

  return (
    <div className="login-page">
      <p>{props.t('common:enter-account-info')}</p>
      <div className="columns">
        <div className="column is-6">
          <form
            id="login-form"
            onSubmit={props.handleSubmit(props._handleSubmit)}
            noValidate
            className="m-b-md m-t-md"
          >
            <Input
              name="username"
              id="username"
              label={usernameText}
              required
              icon="email"
              horizontal
              formComponent
              placeholder={usernameTipText}
              help={props.t('common:username-help')}
              validate={[
                defaultValidators.required,
                defaultValidators.email
              ]}
            />
            <Input
              id="password"
              name="password"
              type="password"
              label={passwordText}
              required
              icon="lock"
              horizontal
              formComponent
              placeholder={props.t('common:password-tip')}
              validate={[
                defaultValidators.required,
                defaultValidators.password
              ]}
            />
            { props.error &&
              <Error message={props.t(props.error)} />
            }
            <FormControlWrapper
              horizontal
              labelOffset
            >
              <Button
                disabled={props.submitting || props.isSubmitDisabled || props.loading}
                loading={props.loading}
                outlined
                btType="primary"
              >
                {props.t('common:submit')}
              </Button>
            </FormControlWrapper>
          </form>
          <p><Link href="/register"><a>{props.t('register')}</a></Link> {props.t('if-dont-have-account')}</p>
          <p><Link href="/password-reset"><a>{props.t('forgot-password')}?</a></Link></p>
        </div>
      </div>
    </div>
  )
}

export default Login



// WEBPACK FOOTER //
// ./components/Login/index.js